import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SCRIPTS_SLICE_NAME, ScriptsState, SetScriptReplacementPayload } from './scripts.slice.types.ts';

const initialState: ScriptsState = {
  replacements: {},
};

export const scriptsSlice = createSlice({
  name: SCRIPTS_SLICE_NAME,
  initialState,
  reducers: {
    setScriptReplacement: (state, action: PayloadAction<SetScriptReplacementPayload>) => {
      state.replacements[action.payload.key] = action.payload.value;
    },
    resetReplacements: (state) => {
      state.replacements = {};
    },
  },
});

export const { setScriptReplacement, resetReplacements } = scriptsSlice.actions;

export const ScriptsSlice = scriptsSlice.reducer;
